function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 778;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/icons\/[^\/]+\.(svg)$
// module id = 778
// module chunks = 1 3